/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var consts = require('./consts');

var olextent = __ol__.extent;
var olproj = __ol__.proj;
var getExtentCenter = olextent.getCenter,
    getExtentWidth = olextent.getWidth,
    getExtentHeight = olextent.getHeight,
    boundingExtent = olextent.boundingExtent;
function createOrUpdateExtent(minX, minY, maxX, maxY, extent) {
  if (extent) {
    extent[0] = minX;
    extent[1] = minY;
    extent[2] = maxX;
    extent[3] = maxY;

    return extent;
  } else {
    return [minX, minY, maxX, maxY];
  }
}

/**
 * Get a corner coordinate of an extent.
 * @param {ol.Extent} extent Extent.
 * @param {ol.extent.Corner} corner Corner.
 * @return {ol.Coordinate} Corner coordinate.
 * @see https://github.com/openlayers/openlayers/blob/master/src/ol/extent.js#L482
 */
function getExtentCorner(extent, corner) {
  var coordinate = void 0;
  if (corner === consts.EXTENT_CORNER.BOTTOM_LEFT) {
    coordinate = olextent.getBottomLeft(extent);
  } else if (corner === consts.EXTENT_CORNER.BOTTOM_RIGHT) {
    coordinate = olextent.getBottomRight(extent);
  } else if (corner === consts.EXTENT_CORNER.TOP_LEFT) {
    coordinate = olextent.getTopLeft(extent);
  } else if (corner === consts.EXTENT_CORNER.TOP_RIGHT) {
    coordinate = olextent.getTopRight(extent);
  } else {
    throw new Error('Invalid corner');
  }
  return coordinate;
}

/**
 * Generate a tile grid extent from a projection.  If the projection has an
 * extent, it is used.  If not, a global extent is assumed.
 * @param {ol.ProjectionLike} projection Projection.
 * @return {ol.Extent} Extent.
 * @see https://github.com/openlayers/openlayers/blob/master/src/ol/tilegrid.js#L148
 */
function createExtentFromProjection(projection) {
  projection = olproj.get(projection);
  var extent = projection.getExtent();

  if (!extent) {
    var half = 180 * olproj.METERS_PER_UNIT[consts.PROJ_UNIT.DEGREES] / projection.getMetersPerUnit();
    extent = createOrUpdateExtent(-half, -half, half, half);
  }
  return extent;
}

exports.getExtentCenter = getExtentCenter;
exports.getExtentWidth = getExtentWidth;
exports.getExtentHeight = getExtentHeight;
exports.boundingExtent = boundingExtent;
exports.createOrUpdateExtent = createOrUpdateExtent;
exports.getExtentCorner = getExtentCorner;
exports.createExtentFromProjection = createExtentFromProjection;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/extent.js
// module id = 128
// module chunks = 1